import React, { useEffect, useState } from "react";
import { message, Modal, Form, Input, Button, Row, Col, Select } from "antd";
import moment from "moment";
import { platformApi } from "../../../../api";

const ChassisAllocationModal = (props) => {
  const { open, close, data } = props;
  const [chassisOptions, setChassisOptions] = useState([]);
  const [selectedChassisId, setSelectedChassisId] = useState(null);
  const [selectedEngineNo, setSelectedEngineNo] = useState(""); // NEW state for engine number
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [MFGDate, setMFGDate] = useState(null);
  const [DOMFlag, setDOMFlag] = useState(null);

  useEffect(() => {
    if (data) {
      getChassisNumber();
    }
  }, [data]);

  const getChassisNumber = () => {
    if (!data.color?.id || !data.branch?.id) return;

    const payload = {
      color: data?.color?.id,
      branch: data?.branch?.id,
      vehicle: data?.vehicle?.id,
    };
    platformApi
      .post(`/api/vehicleInventory/getvehicles`, payload)
      .then((res) => {
        const options = res.data.response.data;
        if (options.length < 1) {
          message.info("No chassis Number available in Inventory");
          return;
        }
        setChassisOptions(options);
      });
  };

  const allocateChassis = () => {
    if (!selectedChassisId) {
      setError((prev) => ({
        ...prev,
        CHS: { type: "error", message: "Chassis Number is required!" },
      }));
      return;
    }
    setLoading(true);

    const selectedChassis = chassisOptions.find(
      (opt) => opt.id === selectedChassisId
    );
    if (!selectedChassis) {
      message.error("Invalid chassis selection.");
      setLoading(false);
      return;
    }

    platformApi
      .put(`/api/booking/${data.id}/chassis`, {
        chassisNumber: selectedChassis.chassisNo,
        engineNo: selectedChassis.engineNo,
        batteryNumber: selectedChassis.batteryNo,
      })
      .then((res) => {
        if (res.data.code === 200) {
          message.success("Chassis number added successfully");
          close();
          clearFields();
        } else {
          message.error("Error in Allocating chassis number");
          setLoading(false);
        }
      })
      .catch((error) => {
        message.error("Error allocating chassis number");
        console.error("chassis allocation error:", error);
        setLoading(false);
      });
  };

  const clearFields = () => {
    setError({});
    setMFGDate(null);
    setDOMFlag(null);
    setLoading(false);
    setSelectedChassisId(null);
    setSelectedEngineNo(""); // reset engine no
    setChassisOptions([]);
  };

  const handleChassisChange = (value) => {
    setSelectedChassisId(value);
    setError((prev) => ({ ...prev, CHS: null }));
    const selected = chassisOptions.find((opt) => opt.id === value);
    setSelectedEngineNo(selected?.engineNo || ""); // auto-fill engine number
  };

  return (
    <Modal
      width="80%"
      title={`Allocate Chassis Number : ${data?.bookingId}`}
      visible={open}
      onCancel={() => {
        close();
        clearFields();
      }}
      footer={null}
    >
      <Form layout="vertical">
        {/* Row 1 — Customer + Manufacturer */}
        <Row gutter={16} style={{ marginBottom: 12 }}>
          <Col span={8}>
            <Form.Item label="Customer Name">
              <Input value={data?.customer?.name || ""} readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Customer Contact">
              <Input
                value={data?.customer?.contacts?.[0]?.phone || ""}
                readOnly
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Manufacturer">
              <Input value={data?.vehicle?.manufacturer?.name || ""} readOnly />
            </Form.Item>
          </Col>
        </Row>

        {/* Row 2 — Vehicle + Color + Engine No */}
        <Row gutter={16} style={{ marginBottom: 12 }}>
          <Col span={8}>
            <Form.Item label="Vehicle Model">
              <Input value={data?.vehicle?.modelName || ""} readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Color">
              <Input value={data?.color?.color || ""} readOnly />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Engine No">
              <Input value={selectedEngineNo} readOnly placeholder="Select chassis to auto-fill" />
            </Form.Item>
          </Col>
        </Row>

        {/* Row 3 — Image + Chassis + Button */}
        <Row gutter={16} style={{ marginBottom: 12 }}>
          <Col span={12}>
            <Form.Item label="Vehicle Image">
              {data?.color?.url ? (
                <img
                  src={data?.color.url}
                  alt="Vehicle"
                  style={{
                    width: "100%",
                    maxHeight: 80,
                    objectFit: "contain",
                    border: "1px solid #eee",
                    borderRadius: 4,
                  }}
                />
              ) : (
                <div style={{ color: "#aaa" }}>No Image</div>
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Chassis Number"
              required
              validateStatus={!selectedChassisId && error.CHS ? "error" : ""}
              help={error.CHS?.message}
            >
              <Select
                value={selectedChassisId}
                onChange={handleChassisChange}
                placeholder="Select chassis number"
                disabled={loading}
              >
                {chassisOptions.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.chassisNo?.toUpperCase()}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Button
              type="primary"
              onClick={allocateChassis}
              disabled={!selectedChassisId || loading}
              loading={loading}
              block
            >
              Allocate Chassis
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ChassisAllocationModal;
